/*
 * Простая функция, добавляющая протокол https, если протокол не указан
 * @param link
 */
export function addHttpsProtocol(link: string): string {
    // Если ссылка начинается с /, то она абсолютная и не требуется протокол
    // либо она для автоматической подстановки браузеров //ya.ru
    if (link.startsWith('/')) {
        return link;
    }

    // Если ссылка содержит ://, то протокол считаем что указан
    if (/:\/\//.test(link)) {
        return link;
    }

    return `https://${link}`;
}
